<template>
  <router-link
    v-if="to"
    v-slot="{ href: _href, navigate, isActive }"
    :exact="exact"
    :to="to"
    custom
  >
    <LinkTag
      :href="_href"
      :icon="icon"
      :class="[className, { active: isActive }]"
      :icon-size="iconSize"
      class="link"
      v-bind="$attrs"
      @click="navigate"
    >
      <slot />
    </LinkTag>
  </router-link>
  <LinkTag
    v-else
    :icon="icon"
    :href="href"
    :icon-size="iconSize"
    :class="className"
    class="link"
    v-bind="$attrs"
  >
    <slot />
  </LinkTag>
</template>

<script setup lang="ts">
import LinkTag from '@/components/common/link/LinkTag.vue'

defineProps({
  to: { type: String },
  href: { type: String, default: '#' },
  exact: { type: Boolean, default: false },
  className: { type: String, default: '' },
  icon: { type: String, default: 'arrow-top-right' },
})

const iconSize = 16
</script>

<style scoped lang="postcss">
.link {
  --link-icon-margin: 3px;
}
</style>
